import React from 'react'

/**
 * User table component
 * Gets props from UserManagement
 * @param {*} props 
 * @returns
 */
function RefreshingButton(props) {
  const { 
    refreshing = false,
    onClick = null,
    hidden = false,
    disabled = false,
    children = [],
    buttonStyle = null,
    modalTarget = "",
    id = null,
  } = props;

  return (
    <button 
      type="button" 
      className={buttonStyle ? buttonStyle : "btn"} 
      id={id}
      hidden={hidden} 
      data-bs-toggle={(modalTarget && !refreshing) && "modal"} 
      data-bs-target={modalTarget}
      onClick={!refreshing ? onClick : null} 
      disabled={disabled}
    >
      {refreshing ? 
        <div className="spinner-border" role="status" style={{height: '1rem', width: '1rem'}}/> :
        children
      }
    </button>
  )
}



export default RefreshingButton